import { connect } from 'react-redux';
import styled from 'styled-components';
import * as MDICONS from '@material-ui/icons';
import moment from 'moment';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../../constants/routes';
import { deleteMarker, openDeleteMarkerModal } from '../../../../store/actions/sketchActions';
import React, { Component } from 'react';
import ReactModal from 'react-modal';
import FloorMarkerListDeleteModal from './FloorMarkerListDeleteModal';
import { each } from 'jquery';
import { dateConverter } from '../../../../helper/Helper';
import { get } from 'lodash';


class FloorMarkersListMapless extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showVisibileModal: false,
        }
    }
    /// README: MODAL CONTROLLING
    handleOpenModal = (proid, markerid) => {
        this.props.openDeleteMarkerModal();
        this.setState({
            showVisibileModal: true,
            proid,
            markerid,
        });
    }

    handleCloseModal = () => {
        this.setState({ showVisibileModal: false });
    }


    handleClick = (proid, markerid) => {
        // console.log(proid,markerid)
        this.props.deleteMarker(proid, markerid);

    }

    render() {
        const { handleOpenModalMapless, floorMarkers, handleSetMarkerId, themeColors, modalStyles, sketch, tagLimitReached, defectMarker, defectMarkers, isMarkerAdditionAllowed, alu, snagDetail, userData } = this.props;
        const { isMarkerDeleted } = sketch;
        const { uid, employeeid } = userData;
        const { accessMap } = snagDetail;
        const { markerDeletionAccess } = alu;
        var ueid = uid + employeeid;
        var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
        var isMarkerDeletionToggleAllowed = markerDeletionAccess[accessLevel];
        const ViewTagDetailButton = styled.div`
    .btn {
        color: ${themeColors.themeColor};
        border-color: ${themeColors.themeColor};
        background-color: #fafafa;
        margin: 2px;  
 
        &:hover { 
            color: #fafafa;
            background-color: ${themeColors.themeColor};
        }

        &:active {
            color: #fafafa; 
            background-color: ${themeColors.themeColor};
        }
    }
`;
        const floorMarkersListMapless = (floorMarkers ? floorMarkers.map(eachFloorMarkerDetail => {
            const proid = eachFloorMarkerDetail.proid;
            const markerid = eachFloorMarkerDetail.markerid;
            // console.log(eachFloorMarkerDetail.dateCreated)
            // var parsedDate = eachFloorMarkerDetail.dateCreated? new Date(eachFloorMarkerDetail.dateCreated ?eachFloorMarkerDetail.dateCreated.seconds + eachFloorMarkerDetail.dateCreated.nanoseconds * 10 ** -9 : ''):'';
            // var date = parsedDate !== ''?  moment(parsedDate * 1000).format('dddd, MMMM Do, YYYY') : '';
            // console.log(date.parsedDate);
            var tagOrElevationDateCreated = dateConverter(eachFloorMarkerDetail.dateCreated).parsedDate;
            var tagDeadline = dateConverter(eachFloorMarkerDetail.deadline).parsedDate;
            return (
                <div className="card h-100" key={eachFloorMarkerDetail.id} style={{ borderRadius: '20px', margin: '8px', overflow: 'auto' }}>
                    <ul className="list-group" >
                        <div className="list-group-item d-flex justify-content-between" style={{ borderRadius: '0px', textAlign: 'start' }}>

                            <div className="align-self-start">
                                <h5 style={{ fontWeight: 'bold' }}>{eachFloorMarkerDetail.title}</h5>
                                <p style={{ fontSize: '12px' }}><b style={{ color: themeColors.themeColor }}>Deadline: </b>{tagDeadline}</p>
                                {/* {tagLimitReached ?
                                    <div className="d-flex justify-content-between">
                                        <ViewTagDetailButton themeColors={themeColors}>
                                            <button className="btn btn-default btn-sm float-left" disabled onClick={() => { handleSetMarkerId(markerid) }}>View {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button>
                                            {isMarkerDeletionToggleAllowed ? <button className="btn btn-default btn-sm float-left" disabled onClick={() => { this.handleOpenModal(proid, markerid) }}>Delete {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button> : <React.Fragment />}
                                        </ViewTagDetailButton>
                                         <div className="d-flex align-items-end" style={{fontSize:'11px'}}> -{tagOrElevationDateCreated}</div>
                                    </div>
                                    : <div className="d-flex justify-content-between">
                                        <ViewTagDetailButton themeColors={themeColors}>
                                            <button className="btn btn-default btn-sm float-left" onClick={() => { handleSetMarkerId(markerid) }} >View {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button>
                                            {isMarkerDeletionToggleAllowed ? <button className="btn btn-default btn-sm float-left" onClick={() => { this.handleOpenModal(proid, markerid) }}>Delete {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button> : <React.Fragment />}
                                        </ViewTagDetailButton>
                                        <div className="d-flex align-items-end" style={{fontSize:'11px'}}> -{tagOrElevationDateCreated}</div>
                                    </div>} */}
                            </div>

                            <div className="ml-2 align-self-start">
                                {eachFloorMarkerDetail.identifier !== "1" ? eachFloorMarkerDetail.isDeadlineComplete ?
                                    <span className="badge badge-pill badge-success"> Fixed</span> :
                                    <span className="badge badge-pill badge-danger"> Pending </span> : ''}

                            </div>
                        </div>
                         {/* Card footer */}
                         <div className="card-footer mt-auto" style={{ borderRadius: '5px' }}>
                            <div className="row">
                                <div className="col col-12">
                                    <div className="d-flex">
                                        <div className="flex-fill">
                                            <ViewTagDetailButton themeColors={themeColors}>
                                                {tagLimitReached ?
                                                    <button className="btn btn-default btn-sm float-left" disabled onClick={() => { handleSetMarkerId(markerid, true) }}>View {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button>
                                                    :
                                                    <button className="btn btn-default btn-sm float-left" onClick={() => { handleSetMarkerId(markerid, true) }}>View {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button>
                                                }
                                            </ViewTagDetailButton>
                                        </div>
                                        <div className="align-self-start pl-2">
                                            <ViewTagDetailButton themeColors={themeColors}>
                                                {tagLimitReached ? <button className="btn btn-default btn-sm float-left" disabled onClick={() => { this.handleOpenModal(proid, markerid) }}>Delete {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button>
                                                    : isMarkerDeletionToggleAllowed ? <button className="btn btn-default btn-sm float-left" onClick={() => { this.handleOpenModal(proid, markerid) }}>Delete {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button> : <React.Fragment />
                                                }
                                            </ViewTagDetailButton>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ul>
                </div>
            )
        }) : <React.Fragment />)

        return (
            <div className="container-fluid">
                {/* <div className="row mt-2">
                    <div className="col col-5">
                        <div className="row">
                            <div className="d-flex justify-content-around col col-6">

                                <p style={{ fontSize: "16px", textAlign: "start" }}>
                                    <Link to={ROUTES.IND_PROJECT_DASHBOARD} className="btn btn-sm "><MDICONS.ArrowBackIosRounded />Go Back</Link>
                                </p>
                                {tagLimitReached ?
                                    <button className="align-self-start btn btn-default btn-sm" disabled onClick={handleOpenModalMapless} style={{ borderRadius: '10px' }}>
                                        <span className="badge ml-4" style={{ backgroundColor: `${themeColors.themeColor}`, color: '#fafafa', fontSize: '16px', textAlign: 'start' }}><MDICONS.Room />&nbsp;Add {defectMarker}</span>
                                    </button>
                                    : <button className="align-self-start btn btn-default btn-sm" onClick={handleOpenModalMapless} style={{ borderRadius: '10px' }}>
                                        <span className="badge ml-4" style={{ backgroundColor: `${themeColors.themeColor}`, color: '#fafafa', fontSize: '16px', textAlign: 'start' }}><MDICONS.Room />&nbsp;Add {defectMarker}</span>
                                    </button>}
                            </div>
                            <div className="col col-3">
                            <button className="btn btn-default btn-lg" onClick={handleOpenModalMapless} style={{ borderRadius: '10px' }}>
                                <span className="badge ml-2" style={{ backgroundColor: `${themeColors.themeColor}`, color: '#fafafa' }}> <MDICONS.Room />&nbsp; Add a new tag</span>
                            </button>

                        </div>
                        </div>

                    </div>
                    <div className="col col-7"></div>
                </div> */}
                <div className="d-flex justify-content-start row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 mt-3 ml-1">
                    {isMarkerAdditionAllowed ? tagLimitReached ?
                        <div style={{ borderRadius: '15px', margin: '8px', textAlign: 'center', cursor: 'pointer', PointerEvent: 'none', opacity: '0.5' }} >
                            <ul className="list-group">
                                <div className="list-group-item list-group-item-action" style={{ borderRadius: '15px', paddingTop: '45px' }}>
                                    <div className="" style={{ textAlign: 'center' }}>
                                        <span className="d-flex justify-content-center" ><MDICONS.Add style={{ fontSize: '46px', color: `${themeColors.themeColor}`, }} /></span>
                                        <p className="d-flex justify-content-center" style={{ color: `${themeColors.themeColor}`, fontSize: '16px' }}>Add {defectMarker}</p>
                                    </div>
                                </div>
                            </ul>
                        </div>

                        // tag limit reached then this cond.
                        :
                        <div style={{ borderRadius: '15px', margin: '8px', textAlign: 'center', cursor: 'pointer' }} onClick={handleOpenModalMapless} >
                            <ul className="list-group">
                                <div className="list-group-item list-group-item-action" style={{ borderRadius: '15px', paddingTop: '45px' }}>
                                    <div className="" style={{ textAlign: 'center' }}>
                                        <span className="d-flex justify-content-center" ><MDICONS.Add style={{ fontSize: '46px', color: `${themeColors.themeColor}`, }} /></span>
                                        <p className="d-flex justify-content-center" style={{ color: `${themeColors.themeColor}`, fontSize: '16px' }}>Add {defectMarker}</p>
                                    </div>
                                </div>
                            </ul>
                        </div>

                        // if marker addition is not allowed.
                        : <React.Fragment />
                    }


                    {floorMarkersListMapless}
                </div>
                {/* PART MARKER DELETEION MODAL  */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showVisibileModal && isMarkerDeleted}
                    onRequestClose={() => { this.handleCloseModal() }}
                    contentLabel="Delete Tag"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal() }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <FloorMarkerListDeleteModal proid={this.state.proid} markerid={this.state.markerid} />
                </ReactModal>
            </div>





        )
    }
}

const mapStateToProps = (state) => {
    return {
        floorMarkers: state.firestore.ordered.FloorMarkers,
        themeColors: state.theme,
        modalStyles: state.appControl.modalStyles,
        sketch: state.sketch,
        alu: state.alu,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        userData: state.firebase.profile,

    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        deleteMarker: (proid, markerid) => dispatch(deleteMarker(proid, markerid)),
        openDeleteMarkerModal: () => dispatch(openDeleteMarkerModal()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FloorMarkersListMapless);